<template>
  <div class="imgsort-list">
    <div class="img-list">
      <div class="item" v-for="(item, index) in imgList" @click="showImg(item)" :key="item.designId">
        <div class="img-wrap">
          <img :src="item.designUrl + '?x-oss-process=image/resize,w_200'" alt="" />
        </div>
        <div class="text">
          <div class="text-label">生产者</div>
          <div class="text-value">aaaa</div>
        </div>
        <div class="text">
          <div class="text-label">IP名称</div>
          <div class="text-value">aaaa</div>
        </div>
        <div class="text">
          <div class="text-label">国家</div>
          <div class="text-value">国外</div>
        </div>
        <div class="btn-gourp">
          <el-button type="primary" size="small" icon="el-icon-download">保存</el-button>
          <el-button type="primary" size="small" icon="el-icon-goods">购买</el-button>
        </div>
      </div>
    </div>
    <div class="site-page">
      <el-pagination background :page-count="totalPage" :current-page="pageNum" @current-change="getImgList" layout="prev, pager, next, jumper"></el-pagination>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="375px" @before-close="beforeClose">
      <!-- <div slot="title">
        <el-button type="info" @click="download" class="my-btn-black">下载<i class="el-icon-download el-icon--right"></i></el-button>
      </div> -->
      <div v-if="currentImg" class="currentImg">
        <img :src="currentImg" alt="" />
      </div>
      <el-tabs class="my-tab" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="生产者介绍" name="first">
          <div class="authorDesc">
            <div class="name">小黄人盲盒</div>
            <div class="price">￥149</div>
            <div class="copyright">传媒公司</div>
            <div class="desc">受欢迎受欢迎受欢迎受欢迎受欢迎</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="IP介绍" name="second">IP介绍</el-tab-pane>
      </el-tabs>
      <div class="browse">
        <div class="name"><i class="el-icon-document"></i>小换人.doc</div>
        <el-button type="primary" size="mini">浏览</el-button>
      </div>
      <div class="btn-gourp" style="width:200px;margin: 0 auto;">
        <el-button type="primary" size="small" icon="el-icon-download">保存</el-button>
        <el-button type="primary" size="small" icon="el-icon-goods">购买</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API, { baseUrl } from '../lib/API'
export default {
  name: 'OrderList',
  data() {
    return {
      pageNum: 1,
      totalPage: 0,
      name: '',
      imgList: [],
      dialogVisible: false,
      currentImg: '',
      designKey: '',
      activeName: 'first'
    }
  },
  methods: {
    showImg({ designUrl, designKey }) {
      this.currentImg = designUrl
      this.designKey = designKey
      this.$nextTick(()=> {
        this.dialogVisible = true
      })
    },
    beforeClose() {
      this.currentImg = ''
      this.designKey = ''
    },
    getImgList(val) {
      if (!isNaN(val)) {
        this.pageNum = val
      } else {
        this.pageNum = 1
      }
      new API(this).POST({
        url: '/design/listWithPage',
        params: {
          count: true,
          pageNum: this.pageNum,
          pageSize: 16
        },
        cb: res => {
          let { pages, result } = res
          result.forEach(element => {
            element.load = false
          })
          this.totalPage = pages
          this.imgList = result
        }
      })
    }
  },
  created() {
    // 图案分类
    // new API(this).POST({
    //   url: "/designCategory/findAllDesignCategoryList",
    //   cb: res => {
    //     this.sortData = res;
    //   }
    // });

    // // 图案查询
    this.getImgList()
  }
}
</script>
<style scoped lang="less">

.my-tab /deep/ .el-tabs__item{
  width:50%;
  text-align: center;
}
.my-tab /deep/ .el-tabs__nav {
  width: 100%;
}
.currentImg {
  width: 100%;
  img {
    width: 100%;
  }
}
.btn-gourp {
  margin-top:10px;
  display: flex;
  justify-content: space-between;
}
.my-btn-black {
  background: #000;
}
.authorDesc {
  line-height: 30px;
  .name {
    font-weight: bold;
    font-size: 16px;
  }
  .price {
    color:orange;
  }
  .desc {
    background:#f1f1f1;
    padding: 10px;
    border-radius: 8px;
    margin:10px 0 0;
  }
}
.browse {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 10px rgba(0,0,0,.1);
  padding: 5px 10px;
  margin-bottom:20px;
  border-radius: 5px;
  margin-top:10px;
  .name {
    width:220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  i {
    margin-right:10px;
  }
}
.img-list {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 19%;
    cursor: pointer;
    transition: all .4s;
    // background: #f1f1f1;
    border: 1px solid #ccc;
    border-radius: 10px;
    box-sizing: border-box;
    margin: 0.5%;
    padding: 10px 20px;
    .img-wrap {
      width:100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      border: 10px solid #f1f1f1;
      background:#f1f1f1;
      box-sizing: border-box;
      margin-bottom: 10px;
      img {
        height: 200px;
        display: block;
        display: block;
      }
    }
      .text {
        display: flex;
        line-height:30px;
        .text-label {
          width:80px;
        }
      }
    &:hover {
      box-shadow: 0 0 15px rgba(0,0,0,.2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BuyManage.vue